import React from 'react';
import { connect } from 'react-redux';
import { Form, Input, Select, Tree, Row, Col, message, Button  } from 'antd';
import ModalDom from '../../../../components/Modal';
import { post, postFrom, config } from '../../../../axios';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import {dicRoleStatus, houseTypeLabelMap, roleHouseStatusMap} from '../../../../axios/dictionaries';
import DetailTitle from '../../../../components/DetailTitle';
import {authKeyFn} from '../../../../axios/authKey'
const Option = Select.Option;
const { TreeNode } = Tree;

class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            data: {},
            title: '新增岗位',
            id: '',
            inputWidth: 260,
            isAdmin: 0, //是否为商户管理员 0:false, 1:true
            jurisdictionData: [],
            checkedKeys: []
        }
    }

    render() {
        let { visible, form: { getFieldDecorator } } = this.props;
        let { loading, 
            data, 
            title, 
            inputWidth, 
            isAdmin,
            jurisdictionData, 
            checkedKeys,
        } = this.state;
        const footer = () =>  {
            return(
                isAdmin == 1 ? <div> <Button onClick={this.handleCancel}>取消</Button></div> : null
            )
        }
        const {  getFieldValue } = this.props.form
        const labelValue = getFieldValue('roleHouseStatusList')
        return <ModalDom
            title={title}
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            width={"800px"}
            onCancel={this.handleCancel}
            footer = { footer() }
        >
            <div className="custom" style={{
                marginTop:'-18px'
            }}>
            <Form
                labelCol={{ span: 0 }}
                wrapperCol={{ span: 24 }}
                className="min-height "
            >
                <Row>
                    {
                        isAdmin == 0 ?
                            <Col span={24} >
                                <DetailTitle title="基本信息"/>
                                <CustomRow>
                                    <CustomCol  label="岗位名称">
                                        {getFieldDecorator('name', {
                                            rules: [{
                                                required: true, message: '请输入岗位名称',
                                            }],
                                            initialValue: data.name
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                // style={{ width: inputWidth }}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                </CustomRow>
                                <CustomRow divider>
                                    <CustomCol  label="使用状态">
                                        {getFieldDecorator('status', {
                                            rules: [{
                                                required: true, message: '请选择使用状态',
                                            }],
                                            initialValue: data.status || 1
                                        })(
                                            <Select
                                                showSearch
                                                // style={{ width: inputWidth }}
                                                placeholder="请选择"
                                                optionFilterProp={'children'}
                                            >
                                                {dicRoleStatus.map((item, index) => <Option key={ index } value={ item.value }>{ item.title }</Option>)}
                                            </Select>
                                        )}
                                    </CustomCol>
                                </CustomRow>
                                <CustomRow divider>
                                        <CustomCol  colStyle={{width: 500}} label="管辖房源状态">
                                            {getFieldDecorator('roleHouseStatusList', {
                                                rules: [{
                                                    required: true, message: '请选择管辖房源状态',
                                                }],
                                               initialValue: data.roleHouseStatusList || []
                                            })(
                                                <Select
                                                    mode="multiple"
                                                    tokenSeparators={[',']}
                                                    placeholder="请选择管辖房源状态"
                                                >
                                                    {
                                                        labelValue && labelValue.length > 5 ?
                                                            [] :
                                                            roleHouseStatusMap.map((item, index) => <Select.Option key={ item.value } value={ item.value }>{ item.title }</Select.Option>)
                                                    }
                                                </Select>
                                            )}
                                        </CustomCol>
                                </CustomRow>
                            </Col>
                            :
                            <Col span={24}>
                                <DetailTitle title="基本信息"/>
                                <CustomRow>
                                    <CustomCol label="岗位名称：" labelStyle={{ width: '100px' }}>
                                        <div style={{ width: inputWidth, padding: '0 10px', height: '34px', lineHeight: '34px', fontSize: '16px', overflow: 'auto' }}>{data.name}</div>
                                    </CustomCol>
                                </CustomRow>
                                <CustomRow divider>

                                    <CustomCol label="使用状态：" labelStyle={{ width: '100px' }}>
                                        <div style={{ width: inputWidth, padding: '0 10px', height: '34px', lineHeight: '34px', fontSize: '16px', overflow: 'auto' }}>{data.status == 1 ? "正常" : "停用" }</div>
                                    </CustomCol>

                                </CustomRow>

                            </Col>
                    }

                </Row>

                <DetailTitle title="分配权限"/>
                {
                    !isAdmin
                        ? <Tree
                        multiple={true}
                        checkable={true}
                        onCheck={
                            (checkedKeys) => {
                                this.setState({ checkedKeys });
                            }
                        }
                        style={{
                            maxHeight: "48vh",
                            overflowY: "scroll"
                        }}
                        checkedKeys={checkedKeys}
                        defaultExpandAll
                    >
                        {this.renderTreeNodes(jurisdictionData)}
                    </Tree>
                    : <div style={{ textAlign: 'center' }}>已拥有全部权限</div>
                    }
                </Form>
            </div>
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this)
        console.log(this.props.config)
        let menusAuth = this.props.config.auth.menusAuth,

            newAuthKey =  authKeyFn(menusAuth);

        this.setState({
            jurisdictionData:newAuthKey
        })
    }

    handleCancel = () => {
        this.props.handleCancel();
        this.setState({data: {}, loading: false, title: "新增岗位", checkedKeys: [] })
    }


    loadPack = ({id, platformisAdmin}) => {
        this.setState({ loading: true, title: "编辑岗位", id });
        let data = { roleId: id, owner: this.props.owner };
        postFrom({
            url: config.API_role_getById,
            data,
        }).then(res => {
            let checkedKeys = [];

            res.rightStr && (checkedKeys = res.rightStr.split(','))

            //res.roleHouseStatusList = res.roleHouseStatusList ? res.roleHouseStatusList.toString():"";


            this.setState({ data: res, loading: false,isAdmin:res.isAdmin, checkedKeys }, //是否是商户管理员
                () => {
                    if(platformisAdmin == 1) {
                        this.setState({
                            isAdmin : platformisAdmin //再次更新一定不是商户管理员
                        });
                    }
                });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        })
    }

    setIsAdmin() { //设置为系统管理员
        this.setState({ isAdmin: 0 });
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {

            if(!error) {
                this.setState({loading: true});
                let data = {},
                NOW_URL = '',
                responText = '',
                { checkedKeys } = this.state;

                values.rightStr = checkedKeys.join();
                data = Object.assign({}, values, { owner: this.props.owner, merchantId: this.props.parentMerchantId, isAdmin: '0' });

                if(this.props.handlecreateOrEdit){
                    NOW_URL = config.API_role_edit;
                    responText = '编辑';
                    data.id = this.state.id;
                } else {
                    NOW_URL = config.API_role_create;
                    responText = '新增'
                }

                post({
                    url: NOW_URL,
                    data,
                }).then(res => {
                    this.setState({loading: false, checkedKeys: []});
                    this.props.handleGetList();
                    this.handleCancel();
                    message.success(`${responText}成功`);
                }).catch(err => {
                    message.error(err.message || '接口异常');
                    this.setState({ loading: false });
                });

            }
        })
    }



    renderTreeNodes = data => {
        return data.map(item => {
            if (item.children) {
                return (
                    <TreeNode selectable={false} title={item.name} key={item.code} dataRef={item}>
                        {this.renderTreeNodes(item.children)}
                    </TreeNode>
                );
            }
            return <TreeNode selectable={false} title={item.name} key={item.code} dataRef={item} />;
        })
    }

}
const mapStateToProps = state => {
    return state
};

export default connect(mapStateToProps)(Form.create()(Page));



// WEBPACK FOOTER //
// ./src/page/Merchant/components/RoleAdd/index.js